import { UserApi } from './';

const {REACT_APP_API_BASE_URL} = process.env;

export class FramesApi {
    static getAllFrames (eventID) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/frames`, {
            ...UserApi.GetDefualtMethod
        });
    }

    /**
     * send multipart form data file
     * @param {String} eventID
     * @param {FormData} data 
     */
    static uploadFrame (eventID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/frames`, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            body: data
        });
    }

    static updateFrame (eventID, frameID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/frames/${frameID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    static deleteFrame (eventID, frameID) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/frames/${frameID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'DELETE'
        });
    }
}




// WEBPACK FOOTER //
// ./src/services/frames.js